const Construction = {

    "construction": "Construction",
    "project": "Project",
    "phase_status": "Phase Status",
    "cp_status": "Construction Status",
    "current_stage": "Current Stage",
    "started_at": "Started At",
    "completed_at": "Completed At",
    "search": "Search",
    "project_details": "Project Details",
    "stage_timeline": "Stage Timeline",
    "daily_log": "Daily Log",
    "view_all": "View all",
    "status": "Status",
    "created_at": "Created At",
    "filter_from_date": "From Date",
    "filter_to_date": "To Date",
    "reached_on": "Reached",
    "in_progress_since": "In progress · since",
    "more_stages": "... {{count}} more stages ...",
    "mark_as_complete": "Mark as Complete",
    "confirm_stage_complete_title": "Mark stage as complete?",
    "confirm_stage_complete_text": "Are you sure you want to mark this stage as complete?",
    "stage_marked_complete": "Stage marked as complete",
    "reopen": "Reopen",
    "confirm_stage_reopen_title": "Reopen stage?",
    "confirm_stage_reopen_text": "Are you sure you want to reopen this stage?",
    "stage_reopened": "Stage reopened successfully",
    "complete_phase": "Complete Phase",
    "confirm_complete_phase_title": "Complete phase?",
    "confirm_complete_phase_text": "Are you sure you want to mark this phase as completed?",
    "phase_completed_success": "Phase completed successfully",
    "complete_project_construction": "Complete Project Construction",
    "confirm_complete_project_construction_title": "Complete project construction?",
    "confirm_complete_project_construction_text": "Are you sure you want to promote this project construction?",
    "project_construction_promoted_success": "Construction project promoted successfully",
    "log_date": "Log Date",
    "work_status": "Work Status",
    "work_description": "Work Description",
    "total_labour_count": "Total Labour",
    "weather_conditions": "Weather Conditions",
    "resources_short_supply": "Resources Short Supply",
    "remarks": "Remarks",

    "error_project_id": "Select Project",
    "error_phase_status": "Select Phase Status",

    "table_project_name": "PROJECT",
    "table_contact": "CONTACT",
    "table_phase_status": "PHASE",
    "table_cp_status": "STATUS",
    "table_current_stage": "CURRENT STAGE",
    "table_started_at": "STARTED AT",
    "table_log_date": "DATE",
    "table_stage": "STAGE",
    "table_status": "STATUS",
    "table_labour": "LABOUR",
    "table_weather": "WEATHER",
    "table_work_status": "WORK STATUS",
    "table_stage_status": "STAGE STATUS",
    "table_work_description": "WORK DESCRIPTION",
    "table_files": "FILES",

    "phase_1": "Phase 1",
    "phase_2": "Phase 2",

    "cp_status_draft": "Draft",
    "cp_status_in_progress": "In Progress",
    "cp_status_completed": "Completed",
    "cp_status_cancelled": "Cancelled",

}

export default Construction;
